import React, { useState } from 'react';
import WhatsAppConfig from './WhatsAppConfig';
import TemplatesView from './TemplatesView';
import AIConfigDashboard from './AIConfigDashboard';
import CreateTemplate from './CreateTemplate';
import AutoReplyTab from '../../Components/WhatsApp/AutoReplyTab';

const WhatsAppSettings = () => {
  const [activeTab, setActiveTab] = useState('config');
  const [showCreateTemplate, setShowCreateTemplate] = useState(false);

  const handleCreateClick = () => {
    setShowCreateTemplate(true);
  };

  const handleCreateCancel = () => {
    setShowCreateTemplate(false);
  };

  const handleTemplateAdded = () => {
    setShowCreateTemplate(false);
  };

  return (
    <div className="container-fluid p-4" style={{ background: '#fff', borderRadius: '12px', minHeight: '85vh', boxShadow: '0 4px 20px rgba(0,0,0,0.05)' }}>

      {/* Tab Navigation — hide when create form is open */}
      {!showCreateTemplate && (
        <div className="d-flex align-items-center gap-3 border-bottom pb-3 mb-4">
          <button
            onClick={() => setActiveTab('config')}
            className={`btn ${activeTab === 'config' ? 'btn-primary' : 'btn-light'}`}
            style={{ fontWeight: 600, borderRadius: '8px', padding: '8px 16px' }}
          >
            WhatsApp Config
          </button>
          <button
            onClick={() => setActiveTab('templates')}
            className={`btn ${activeTab === 'templates' ? 'btn-primary' : 'btn-light'}`}
            style={{ fontWeight: 600, borderRadius: '8px', padding: '8px 16px' }}
          >
            Templates
          </button>
          <button
            onClick={() => setActiveTab('autoreply')}
            className={`btn ${activeTab === 'autoreply' ? 'btn-primary' : 'btn-light'}`}
            style={{ fontWeight: 600, borderRadius: '8px', padding: '8px 16px' }}
          >
            Auto Reply
          </button>
          <button
            onClick={() => setActiveTab('ai')}
            className={`btn ${activeTab === 'ai' ? 'btn-primary' : 'btn-light'}`}
            style={{ fontWeight: 600, borderRadius: '8px', padding: '8px 16px' }}
          >
            AI Config
          </button>
        </div>
      )}

      {/* Render subcomponents */}
      <div>
        {showCreateTemplate ? (
          <CreateTemplate
            onCancel={handleCreateCancel}
            onAddTemplate={handleTemplateAdded}
          />
        ) : (
          <>
            {activeTab === 'config' && <WhatsAppConfig />}
            {activeTab === 'templates' && (
              <TemplatesView onCreateClick={handleCreateClick} />
            )}
            {activeTab === 'autoreply' && <AutoReplyTab />}
            {activeTab === 'ai' && <AIConfigDashboard />}
          </>
        )}
      </div>
    </div>
  );
};

export default WhatsAppSettings;
